import React from 'react';
import { Image as BuilderImage } from '@builder.io/react';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

const TalksListItem = ({ talk, avatarPlaceholder }) => {
  if (!talk || talk.tags?.includes('exclude-from-session-list')) {
    return <></>;
  }
  return (
    <div key={talk.id} className='blog-item pb-60'>
      <div className='blog-content'>
        <ul className='blog-meta'>
          <li>
            {talk.speakers.map(({ pretalxSpeaker }, i) => {
              const separator = talk.speakers.length - 1 > i ? ' | ' : ''
              return (
                <span key={pretalxSpeaker.id}>
                  <Link to={pretalxSpeaker.path}>
                    {pretalxSpeaker.name} {pretalxSpeaker.company ? `(${pretalxSpeaker.company})` : ''}
                  </Link>
                  {separator}
                </span>
              );
            })}
          </li>
        </ul>
        <ul className='blog-meta-images'>
          <li>
            {talk.speakers.map(({ pretalxSpeaker }) => (
              <div key={pretalxSpeaker.id}>
                {pretalxSpeaker.localFile ? (
                  <GatsbyImage
                    image={getImage(pretalxSpeaker.localFile)}
                    alt={`${pretalxSpeaker.name}'s avatar`}
                    style={{ height: 100, width: 100, maxHeight: 100, maxWidth: 100 }}
                  />
                  ) : (
                    <BuilderImage
                      image={avatarPlaceholder}
                      alt={`Placeholder image for ${pretalxSpeaker.name}'s avatar`}
                      style={{ height: 100, width: 100, maxHeight: 100, maxWidth: 100 }}
                    />
                  )
                }
              </div>
            ))}
          </li>
        </ul>
        <h3 className='blog-title'><Link to={talk.path}>{talk.title}</Link></h3>
        {/* {talkDateString ? (
            <h6 className='blog-subtitle'>
              {talkDateString}
            </h6>
          ) : null} */}
        {talk.location ? (
          <h6 className='blog-subtitle mb-0'>
            {talk.location}
          </h6>
        ) : null}

        {/* {talk.isRemote && <Chip type='bb' />}
          {talk.isWorkshop && <Chip type='workshop' />} */}

        {talk.description ? (
          <p
            className='desc margin-0 pt-40 pb-25'
          >
            {talk.description}
          </p>
        ) : (
          <div
            className='desc margin-0 pt-40 pb-25 inner-html'
            style={{ listStyle: 'auto', maxHeight: 150, overflow: 'hidden' }}
            dangerouslySetInnerHTML={{ __html: talk.abstract.childMarkdownRemark.html }}
          />
        )}
        <div className='blog-button orange-btn'>
          <Link to={talk.path}>
            <span className='btn-txt'>Read More</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TalksListItem;
